module.exports = __webpack_public_path__ + "media/images/doodle-8fe9a20ac00551dd3dd242b45550166b.PNG";